<template>
  <form-builder :fields="fields" :data="data" @data="$emit('data', $event)"></form-builder>
</template>

<script>
import FormBuilder from '../FormBuilder.vue'

export default {
  name: 'TrainerForm',
  components: {
    FormBuilder
  },
  props: {
    trainer: Object
  },
  data () {
    return {
      // start with a mutable copy of the trainer data, if we have a trainer
      data: this.trainer ? JSON.parse(JSON.stringify(this.trainer)) : null,
      // form builder
      fields: [
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          value: 'test',
          required: true
        },
        {
          name: 'email',
          label: 'Email',
          type: 'email',
          required: true
        },
        {
          name: 'phone',
          label: 'Phone',
          type: 'text'
        },
        {
          name: 'address',
          label: 'Address',
          type: 'text'
        },
        {
          name: 'city',
          label: 'City',
          type: 'text'
        },
        {
          name: 'state',
          label: 'State',
          type: 'text'
        },
        {
          name: 'zipCode',
          label: 'Zip Code',
          type: 'text'
        },
        {
          name: 'video',
          label: 'Video URL',
          type: 'text'
        },
        {
          name: 'certifications',
          label: 'Certifications',
          type: 'text'
        },
        {
          name: 'specialties',
          label: 'Specialties',
          type: 'text'
        },
        {
          name: 'bio',
          label: 'Bio',
          type: 'textarea'
        }
      ]
    }
  }
}
</script>
